import {
  Box,
  Card,
  Divider,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import { FormikProps } from "formik";
import CustomSelect from "../../../../../../components/CustomSelect";
// import { usePatientsList } from "../../../../../../queries/use-get-patients";
// import { placesOfService } from "../add-super-bill-components/places-of-service";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import dayjs from "dayjs";
import CustomDatePicker from "../../../../../../components/CustomDatePicker";
import Input from "../../../../../../components/Input";
import OutlineCard from "../../../../../../components/OutlineCard";
import { STATE_LIST } from "../../../../../../constants";
import CardView from "../../../patient/patient-list/patient-chart-new/assessment/summary/components/CardView";
import { UPDATE_CLAIM_FORM_TYPE } from "../claims-constants";

// import { useDebounce } from "../../../../../../hooks/use-debounce";

interface PatientConditionForClaimProps {
  formik: FormikProps<UPDATE_CLAIM_FORM_TYPE>;
  readOnly?: string;
}

const PatientConditionForClaim = ({
  formik,
  readOnly,
}: PatientConditionForClaimProps) => {
  const { values, setFieldValue } = formik;

  const checkBoxHandler = (value: string, name: string) => {
    if (value === "no") {
      setFieldValue(name, false);
    } else if (value === "yes") {
      setFieldValue(name, true);
    }
  };

  const radioGroupValues = (value?: boolean | null) => {
    if (value === null || value === undefined) {
      return null;
    }
    return value ? "yes" : "no";
  };

  return (
    <Box mt={1}>
      <CardView
        title="IS PATIENT CONDITION RELATED TO"
        titleIcon={
          <ArticleOutlinedIcon sx={{ color: "orange" }} fontSize="small" />
        }
      >
        <Grid container spacing={2}>
          {/* Left Section: Modern Card with shadow */}
          <Grid item xs={12} md={6}>
            <OutlineCard>
              <Grid container spacing={1}>
                {/* Employment */}
                <Grid container item alignItems="center" spacing={1}>
                  <Grid item xs={12} sm={4}>
                    <FormLabel
                      component="legend"
                      sx={{
                        fontWeight: 500,
                        color: "text.primary",
                        fontSize: "0.875rem",
                      }}
                    >
                      Employment
                    </FormLabel>
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <RadioGroup
                      row
                      value={radioGroupValues(
                        formik.values.conditionRelatedToEmployment
                      )}
                      onChange={(_, value) => {
                        checkBoxHandler(value, "conditionRelatedToEmployment");
                      }}
                      name="conditionRelatedToEmployment"
                    >
                      <FormControlLabel
                        disabled={!!readOnly}
                        value="yes"
                        control={<Radio size="small" />}
                        label="Yes"
                        sx={{ mr: 1.5 }}
                      />
                      <FormControlLabel
                        disabled={!!readOnly}
                        value="no"
                        control={<Radio size="small" />}
                        label="No"
                      />
                    </RadioGroup>
                  </Grid>
                </Grid>
                {/* Auto Accident */}
                <Grid container item alignItems="flex-start" spacing={1}>
                  <Grid item xs={12} sm={4}>
                    <FormLabel
                      component="legend"
                      sx={{
                        fontWeight: 500,
                        color: "text.primary",
                        fontSize: "0.875rem",
                        pt: 0.5,
                      }}
                    >
                      Auto Accident
                    </FormLabel>
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <Grid container direction="column" spacing={1} xs={6}>
                      <Grid item xs={6}>
                        <RadioGroup
                          row
                          value={radioGroupValues(
                            formik.values.conditionRelatedToAutoAccident
                          )}
                          onChange={(_, value) => {
                            checkBoxHandler(
                              value,
                              "conditionRelatedToAutoAccident"
                            );
                            if (value === "no") {
                              setFieldValue("state", null);
                            }
                          }}
                          name="conditionRelatedToAutoAccident"
                        >
                          <FormControlLabel
                            disabled={!!readOnly}
                            value="yes"
                            control={<Radio size="small" />}
                            label="Yes"
                            sx={{ mr: 1.5 }}
                          />
                          <FormControlLabel
                            disabled={!!readOnly}
                            value="no"
                            control={<Radio size="small" />}
                            label="No"
                          />
                        </RadioGroup>
                      </Grid>
                      {formik.values.conditionRelatedToAutoAccident ===
                        true && (
                        <Grid item xs={12}>
                          <CustomSelect
                            readOnly={!!readOnly}
                            label="State"
                            name="state"
                            options={STATE_LIST}
                            value={formik?.values.state}
                            onChange={(option) => {
                              formik.setFieldValue(`state`, option);
                            }}
                            handleBlur={formik.handleBlur}
                            error={formik.touched.state && formik.errors.state}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
                {/* Other Accident */}
                <Grid container item alignItems="center" spacing={1}>
                  <Grid item xs={12} sm={4}>
                    <FormLabel
                      component="legend"
                      sx={{
                        fontWeight: 500,
                        color: "text.primary",
                        fontSize: "0.875rem",
                      }}
                    >
                      Other Accident
                    </FormLabel>
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <RadioGroup
                      row
                      value={radioGroupValues(
                        formik.values.conditionRelatedToOtherAccident
                      )}
                      onChange={(_, value) => {
                        checkBoxHandler(
                          value,
                          "conditionRelatedToOtherAccident"
                        );
                      }}
                      name="conditionRelatedToOtherAccident"
                    >
                      <FormControlLabel
                        disabled={!!readOnly}
                        value="yes"
                        control={<Radio size="small" />}
                        label="Yes"
                        sx={{ mr: 2 }}
                      />
                      <FormControlLabel
                        disabled={!!readOnly}
                        value="no"
                        control={<Radio size="small" />}
                        label="No"
                      />
                    </RadioGroup>
                  </Grid>
                </Grid>
              </Grid>
            </OutlineCard>
          </Grid>
          {/* Right Section: Dates and Claim Code */}
          <Grid item xs={12} md={6}>
            <OutlineCard
              elevation={0}
              sx={{
                p: 2,
                border: "1px solid",
                borderColor: "divider",
                height: "100%",
              }}
            >
              <Grid container spacing={2.5}>
                <Grid item xs={12} sm={6}>
                  <CustomDatePicker
                    disabled={!!readOnly}
                    maxDate={dayjs(new Date())}
                    value={formik.values.dateOfCurrentIllness}
                    label="Date of Current Illness"
                    onChange={(val) => {
                      formik.setFieldValue("dateOfCurrentIllness", val);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CustomDatePicker
                    disabled={!!readOnly}
                    maxDate={dayjs(new Date())}
                    value={formik.values.otherDate}
                    label="Other Date"
                    onChange={(val) => {
                      formik.setFieldValue("otherDate", val);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Input
                    label="Claim Code"
                    textFieldProps={{
                      disabled: !!readOnly,
                      placeholder: "Enter Claim Code",
                      name: "claimCodes",
                      value: values.claimCodes,
                      onChange: formik.handleChange,
                      onBlur: formik.handleBlur,
                    }}
                    error={
                      formik.touched?.claimCodes &&
                      (formik.errors?.claimCodes as any)
                    }
                  />
                </Grid>
              </Grid>
            </OutlineCard>
          </Grid>
        </Grid>
        <Divider
          sx={{
            mt: 1,
            mb: 1,
            borderColor: "black",
            borderWidth: "1px",
          }}
        />
        <Grid container spacing={2}>
          {/* Left Section: Modern Card */}
          <Grid item xs={12} md={6}>
            <OutlineCard
              elevation={0}
              sx={{
                p: 2,
                border: "1px solid",
                borderColor: "divider",
                height: "100%",
              }}
            >
              <Grid container spacing={1.5}>
                {/* from to date of patient unable to work */}
                <Grid item xs={12}>
                  <FormLabel
                    component="legend"
                    sx={{
                      fontWeight: 500,
                      color: "text.primary",
                      fontSize: "0.875rem",
                      mb: 0.5,
                      display: "block",
                    }}
                  >
                    Dates patient unable to work in current occupation
                  </FormLabel>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CustomDatePicker
                    disabled={!!readOnly}
                    value={formik.values.unableToWorkFrom}
                    label="From"
                    onChange={(val) => {
                      formik.setFieldValue("unableToWorkFrom", val);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CustomDatePicker
                    disabled={!!readOnly}
                    value={formik.values.unableToWorkTo}
                    label="To"
                    onChange={(val) => {
                      formik.setFieldValue("unableToWorkTo", val);
                    }}
                  />
                </Grid>
                {/* Resubmission Code (22) */}
                <Grid item xs={12} sm={6}>
                  <CustomSelect
                    readOnly={!!readOnly}
                    label="Resubmission Code"
                    name="resubmissionCode"
                    options={[]}
                    value={formik?.values.resubmissionCode}
                    onChange={(option) => {
                      formik.setFieldValue(`resubmissionCode`, option);
                    }}
                  />
                </Grid>
                {/* Acceptance Assignment (27) */}
                <Grid item xs={12} sm={6}>
                  <CustomSelect
                    readOnly={!!readOnly}
                    label="Acceptance Assignment"
                    name="acceptAssignment"
                    options={[]}
                    value={formik?.values.acceptAssignment}
                    onChange={(option) => {
                      formik.setFieldValue(`acceptAssignment`, option);
                    }}
                  />
                </Grid>
              </Grid>
            </OutlineCard>
          </Grid>
          {/* Right Section: Dates and Claim Code */}
          <Grid item xs={12} md={6}>
            <Card
              elevation={0}
              sx={{
                p: 2,
                borderRadius: 2,
                boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                border: "1px solid",
                borderColor: "divider",
                backgroundColor: "background.paper",
                height: "100%",
              }}
            >
              <Grid container spacing={1.5}>
                <Grid item xs={12}>
                  <FormLabel
                    component="legend"
                    sx={{
                      fontWeight: 500,
                      color: "text.primary",
                      fontSize: "0.875rem",
                      mb: 0.5,
                      display: "block",
                    }}
                  >
                    Hospitalization dates related to current service
                  </FormLabel>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CustomDatePicker
                    disabled={!!readOnly}
                    value={formik.values.hospitalizationFrom}
                    label="From"
                    onChange={(val) => {
                      formik.setFieldValue("hospitalizationFrom", val);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <CustomDatePicker
                    disabled={!!readOnly}
                    value={formik.values.hospitalizationTo}
                    label="To"
                    onChange={(val) => {
                      formik.setFieldValue("hospitalizationTo", val);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Input
                    label="Original Reference Number"
                    textFieldProps={{
                      disabled: !!readOnly,
                      placeholder: "Enter Original Reference Number",
                      name: "originalReferenceNumber",
                      value: values.originalReferenceNumber,
                      onChange: formik.handleChange,
                      onBlur: formik.handleBlur,
                    }}
                    error={
                      formik.touched?.originalReferenceNumber &&
                      (formik.errors?.originalReferenceNumber as any)
                    }
                  />
                </Grid>
                {/* Other Claim Id */}
                <Grid item xs={12} sm={6}>
                  <CustomSelect
                    readOnly={!!readOnly}
                    label="Other Claim Id"
                    name="otherClaimId"
                    options={[]}
                    value={formik?.values.otherClaimId}
                    onChange={(option) => {
                      formik.setFieldValue(`otherClaimId`, option);
                    }}
                  />
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </CardView>
    </Box>
  );
};

export default PatientConditionForClaim;
